
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "Footer",
  components: {},
})
export default class Footer extends Vue {
  proviceArr: any = [
    {
      label: "黄石市发改委",
      value: "http://fgw.huangshi.gov.cn/",
    },
    {
      label: "黄石市科技局",
      value: "http://kjj.huangshi.gov.cn/",
    },
    {
      label: "黄石市经信局",
      value: "http://jxw.huangshi.gov.cn/",
    },
    {
      label: "黄石市商务局",
      value: "http://sww.huangshi.gov.cn/",
    },
    {
      label: "黄石市市场监督管理局",
      value: "http://scjg.huangshi.gov.cn/",
    },
    {
      label: "黄石市财政局",
      value: "http://czj.huangshi.gov.cn/",
    },
  ];
  proviceType: any = "";
  cityArr: any = [
    {
      label: "大冶市政府",
      value: "http://www.hbdaye.gov.cn",
    },
    {
      label: "阳新县政府",
      value: "http://www.yx.gov.cn/",
    },
    {
      label: "黄石港区政府",
      value: "http://www.huangshigang.gov.cn/",
    },
    {
      label: "西塞山区政府",
      value: "http://www.xisaishan.gov.cn",
    },
    {
      label: "下陆区政府",
      value: "http://www.xialuqu.gov.cn/",
    },
    {
      label: "开发区·铁山区政府",
      value: "http://www.hsdz.gov.cn/",
    },
  ];
  cityType: any = "";
  partTypesChanged(value: any) {
    window.open(value);
  }
}
